module.exports = __webpack_public_path__ + "static/img/shopNews_03.948ca55.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shopNews_03.png
// module id = 3137
// module chunks = 1